import { render, staticRenderFns } from "./addMaterialDialog.vue?vue&type=template&id=4ce72e11&scoped=true"
import script from "./addMaterialDialog.vue?vue&type=script&lang=js"
export * from "./addMaterialDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce72e11",
  null
  
)

export default component.exports